import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { JSX } from 'react';

import type { UserModules } from '@/constants/modules';

interface ModuleRouteProps {
  module: UserModules;
  children: JSX.Element;
}

export function ModuleRoute({ module, children }: ModuleRouteProps) {
  const { tokenService } = useAuth();
  const location = useLocation();

  if (!tokenService?.getModules().includes(module))
    return <Navigate to="/" state={{ from: location }} />;

  return children;
}
